export default __webpack_public_path__ + "ecolepratique.9ecf7e6.png";